
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Container, Card } from "components/common";
import axios from "axios";
import { Wrapper, Grid, Item, Content, Stats } from "./styles";
import { HoverableCard } from 'react-hoverable-card'
import 'react-hoverable-card/dist/index.css'
import styled from 'styled-components';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";

export const Blogs = () => {
  const { theme } = useContext(ThemeContext);
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    fetch('https://medium-profile-fetch.herokuapp.com/profile/@nishiagr19').then(result => result.json()).then(done => {
      //console.log(done);
      let myblogs = done.items;
      myblogs.forEach(item=>{
        item.description=item.content.replace(/(<([^>]+)>)/gi, "");
        item.description=item.description.slice(0,180);
        item.description=item.description+"...";
       // console.log(item.description);
      })
      myblogs.splice(3);
      setBlogs(myblogs);
    })
  }, []);

  const BigTitle = styled.a({
    textTransform: "uppercase",
    textDecoration: "none",
    fontSize: "1rem",
    color: `${theme === "light" ? "#000" : "#fff"} !important`,
  });
  const Heading = styled.h1({
    fontSize: "3rem",
    color: `rgb(228 93 93) !important`,
    '@media(max-width: 700px)': {
      fontSize: '1.5rem'
    }
  });
  const Div = styled.div({
    textAlign: "left"
  });

  return (
    <Wrapper as={Container} id="education">
      {<Heading>Yes, I love to write as well!</Heading>}
      <Grid theme={theme}>
        {blogs.map((node) => (
          <ScrollAnimation animateIn="animate__zoomIn" duration="3" >
            <div key={node.id}>
              <HoverableCard
                cardTitle={node.title}
                cardDescription={`${node.description}`}
                cardImage={`https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-6zOw9V6A2uIWXCWGotwquIF_cSWZSvwhFW9yaxsbvBC8ULgpx5HVYeyS5x5a2q6wvZ4&usqp=CAU`}
                hoverBgColor="grey"
              />
               <BigTitle
                theme={theme} href={node.link}>Read on Medium</BigTitle>
            </div></ScrollAnimation>
        ))}
      </Grid>
      <br/>
      <Div >
      <BigTitle
       theme={theme} href="https://medium.com/@nishiagr19" >Read more on Medium.....</BigTitle></Div>
    </Wrapper>
  );
};
